import { Component, OnInit } from '@angular/core';
import { ImportedDataService } from '@src/services/importedData.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { ImportedFile } from '@src/model/importedFile';
import { ImportedRetailerFileEntry } from '@src/model/importedRetailersFileEntry';
import { ImportedFileError } from '@src/model/importedFileError';
import { DownloadFileService } from '@src/services/files/downloadfile.service';
import { ImportedFileHelper } from '@src/base-components/management/utils/imported-file-helper';
import { UploadType } from '@src/model/Enums/uploadType';
import { ImportedRetailersFileMetrics } from '@src/model/importedRetailersFileMetrics';
import { NgxDatatableBase } from '@src/shared/tables/ngx-datatable-base';
import { fakeAsync } from '@angular/core/testing';

@Component({
    selector: 'app-imported-retailers-log',
    templateUrl: './imported-retailers-log.component.html'
})
export class ImportedRetailersLogComponent extends NgxDatatableBase implements OnInit {
    importedRetailer: ImportedFile = new ImportedFile();
    fileId: number;

    constructor(private importDataService: ImportedDataService,
        private route: ActivatedRoute,
        private downloadFileService: DownloadFileService,
        translateService: TranslateService) {
        super(translateService);
    }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params['id']) {
                this.fileId = +params['id'];
                this.importDataService.getRetailerLog(this.fileId).subscribe(
                    r => {
                        r.uploadStatusStr = ImportedFileHelper.computeFileStatus(r.uploadStatus);
                        r.uploadTypeStr = UploadType[r.uploadType];
                        this.importedRetailer = r;
                    }
                );
            }
        });
    }

    downloadRetailerFile() {
        this.importDataService.downloadRetailerLog(this.fileId).subscribe(data => {
            this.downloadFileService.downloadFile(data);
        });
    }

    get HaveErrorStatus() {
        return this.importedRetailer.uploadStatusStr === 'error';
    }
}